// Helper.ts
const shortDay = (d: Date) =>
  `${d.getDate()} ${d.toLocaleDateString('en-GB', { month: 'short' })}`;

export default {
  formatDate(
    date: Date,
    schedule: 'DAILY' | 'WEEKLY' | 'MONTHLY' | 'CUSTOM' = 'DAILY'
  ): string {
    if (schedule === 'DAILY') {
      return shortDay(date);
    }

    if (schedule === 'WEEKLY') {
      const day = date.getDay();
      const start = new Date(date);
      start.setDate(date.getDate() - day);
      start.setHours(0, 0, 0, 0);
      const end = new Date(start);
      end.setDate(start.getDate() + 6);
      end.setHours(23, 59, 59, 999);
      return `${shortDay(start)} – ${shortDay(end)}`;
    }

    if (schedule === 'MONTHLY') {
      return date.toLocaleDateString('en-GB', { month: 'long' });
    }

    return shortDay(date);
  },
};
